import React from 'react';

import { Box } from '@material-ui/core';
import cx from 'classnames';

import { BREAKPOINTS_VALUES } from '../../../../theme';
import { IKImage } from '../../../IKImage';
import { LazyLoadImage } from '../../../LazyloadImage';
import useStyles from './styles';

interface CardImgProps {
  imgPath: string;
  wrapperClass?: string;
  imageClass?: string;
  withLazyLoad?: boolean;
  onClick?: () => {};
}

const CardImg: React.FC<CardImgProps> = ({
  withLazyLoad = false,
  wrapperClass,
  children,
  imgPath,
  imageClass,
  onClick,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Box className={cx(classes.wrapper, wrapperClass)} onClick={() => onClick && onClick()}>
      {withLazyLoad ? (
        <LazyLoadImage
          path={imgPath}
          srcset={[
            { width: 470, height: 275 },
            { width: 770, height: 275 },
            { width: 400, height: 275 },
          ]}
          sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 470px, (max-width:${BREAKPOINTS_VALUES['md']}px) 770px, 400px`}
          className={cx(classes.img, imageClass)}
          imageWrapperClass={classes.lazyLoadWrapper}
          data-testid={rest['data-testid']}
        />
      ) : (
        <IKImage
          path={imgPath}
          srcset={[
            { width: 470, height: 275 },
            { width: 770, height: 275 },
            { width: 400, height: 275 },
          ]}
          sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 470px, (max-width:${BREAKPOINTS_VALUES['md']}px) 770px, 400px`}
          className={cx(classes.img, imageClass)}
          data-testid={rest['data-testid']}
        />
      )}
      {children}
    </Box>
  );
};

export default CardImg;
